//import React from 'react';
import React, {  useRef, useState, useEffect } from 'react';
import data from '../data/portfolio.json';
import { useNavigate, Link } from 'react-router-dom';
import { gsap } from 'gsap';
import { useGSAP } from "@gsap/react";



export function Getdata() {
// ------------------------//




// xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
// AUTO SCROLL BACK TO LAST POSITION SCROLLED TO - Marks Intelligent Postion Rememberer lol!
// xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
const [scrollPosition, setScrollPosition] = useState(0);
  useGSAP(() => {

    // 1. Restore position on mount
    const savedPosition = sessionStorage.getItem('scrollPos');
    const savedCategory = sessionStorage.getItem('portCat');

    const handleScroll = () => {
      const currentPosition = window.scrollY;
      setScrollPosition(currentPosition);
      // 2. Save position to sessionStorage
      sessionStorage.setItem('scrollPos', currentPosition);  
    };


    if (savedPosition) {
       let tlscroll = gsap.timeline({});
       tlscroll.to(window, { 
        scrollTo: savedPosition, 
        duration: 1,
        delay:2,
        onComplete: () => {
        // 2. Only start listening AFTER restoration is done
        window.addEventListener('scroll', handleScroll, { passive: true });
  
      }
       });
    } else {
    // No saved pos? Start listening immediately
    window.addEventListener('scroll', handleScroll, { passive: true });
  }
    // 3. Attach event listener
   // window.addEventListener('scroll', handleScroll, { passive: true });
    // 4. Cleanup on unmount
    return () => window.removeEventListener('scroll', handleScroll);

  }, []);


// xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
// F I L T E R    D A T A    >>>>>>>>>>>>>
// xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
const [selectedCategory, setSelectedCategory] = useState(() => {
  // Check if a category was saved, otherwise default to 'All'
  return sessionStorage.getItem('portCat') || 'All';
});

const handleCategoryChange = (e) => {
  const newCategory = e.target.value;
  setSelectedCategory(newCategory); // Update React state
  sessionStorage.setItem('portCat', newCategory); // Save to sessionStorage
};

/*
  // Logic to filter the array based on state
    const filteredData = data.filter(item => 
    selectedCategory === 'All' ? true : item.design_category === selectedCategory
  );
*/
// CHANGE THIS (around line 73):
const filteredData = data
  .filter(item => selectedCategory === 'All' ? true : item.design_category === selectedCategory)
  .sort((a, b) => b.design_id - a.design_id); // Highest design_id first

return (

<div className="gallery">

<div className="portfolio-filter">
  <strong>Filter By Design Category</strong>
  <select value={selectedCategory} onChange={handleCategoryChange}>
    <option value="All">Show all Designs</option>
  <option value="Graphic Design">Graphic Design</option>
  <option value="Web Development">Web Development</option>
</select>
</div>


<div className="thumbnail-wrap">
  {filteredData.map(folder => (
     <Link className="thumbnail" to={`/portfolio/${ folder.design_slug + '_id-' + folder.design_id}`} key={folder.design_id} data-port-id={folder.design_id} > 
        <div className="thumbnail-frame">
          <div className="thumbnail-image">
            <img src={folder.design_thumbnail} alt={folder.design_type +" id "+ folder.design_id} loading="lazy" />
          </div>
              <div className="border-fx-top"></div>
              <div className="border-fx-right"></div>
              <div className="border-fx-bottom"></div>
              <div className="border-fx-left"></div>
       </div>
  <div className="thumbnail-heading">{folder.design_type}</div>
         </Link> 
        ))}     
     </div>
  </div>

  );
};

